import Masonry from 'masonry-layout/dist/masonry.pkgd.min';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';
window.addEventListener('DOMContentLoaded', () => {
    // #grid only exists on the home listing; bail out on every other page
    // (otherwise Masonry receives a null element → "Bad element for masonry: null").
    const grid = document.querySelector('#grid');
    if (!grid) {
      return;
    }
    const images = document.querySelectorAll('.posts-list__item');

    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          var msnry = new Masonry(grid, {
            itemSelector: '.posts-list__item',
            transitionDuration: '0.2s',
            stagger: 30,
            horizontalOrder: true,
          });
          msnry.layout();
        }
      });
    });

    images.forEach(image => {
      observer.observe(image);
    });
  });

document.addEventListener('posts:appended', function () {
  const grid = document.querySelector('#grid');
  if (!grid || $('.posts-list--masonry').length === 0) {
    return;
  }
  var msnry = new Masonry(grid, {
    itemSelector: '.posts-list__item',
    transitionDuration: '0.2s',
    stagger: 30,
    horizontalOrder: true,
  });

  imagesLoaded(grid).on('done', function () {
    // layout Masonry after each image loads
    msnry.reloadItems()
    msnry.layout();
  });
});
